import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MyNavbar from '../components/MyNavbar';
import Footer from '../components/Footer';

const Publications = () => {
    const publicationsDocumentUrl = '/documents/Publications.docx';

    return (
        <div className="publications-page">
            <MyNavbar />

            {/* Hero Section */}
            <section style={{
                backgroundColor: '#0A4B5D',
                color: 'white',
                paddingTop: '5rem',
                paddingBottom: '3rem'
            }}>
                <Container>
                    <Row className="text-center">
                        <Col lg={8} className="mx-auto">
                            <h1 className="display-4 fw-bold mb-4">Publications</h1>
                            <p className="lead">
                                Complete list of research publications including journal articles, 
                                book chapters, and conference proceedings
                            </p>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Document Display Section */}
            <section className="py-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            {/* Publication Types Overview */}
                            <Row className="mb-5">
                                <Col md={4} className="mb-4">
                                    <Card className="h-100 text-center border-0 shadow-sm">
                                        <Card.Body className="p-4">
                                            <i className="fas fa-book fa-3x text-primary mb-3"></i>
                                            <h4 style={{ color: '#0A4B5D' }}>Journal Publications</h4>
                                            <p className="text-muted">
                                                Peer-reviewed journal articles
                                            </p>
                                            <div className="mt-3">
                                                <h2 style={{ color: '#0A4B5D' }}>150+</h2>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                
                                <Col md={4} className="mb-4">
                                    <Card className="h-100 text-center border-0 shadow-sm">
                                        <Card.Body className="p-4">
                                            <i className="fas fa-users fa-3x text-success mb-3"></i>
                                            <h4 style={{ color: '#0A4B5D' }}>Conference Publications</h4>
                                            <p className="text-muted">
                                                Peer-reviewed conference papers
                                            </p>
                                            <div className="mt-3">
                                                <h2 style={{ color: '#0A4B5D' }}>20+</h2>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                
                                <Col md={4} className="mb-4">
                                    <Card className="h-100 text-center border-0 shadow-sm">
                                        <Card.Body className="p-4">
                                            <i className="fas fa-book-open fa-3x text-warning mb-3"></i>
                                            <h4 style={{ color: '#0A4B5D' }}>Book Chapters</h4>
                                            <p className="text-muted">
                                                Invited book chapters
                                            </p>
                                            <div className="mt-3">
                                                <h2 style={{ color: '#0A4B5D' }}>5+</h2>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            {/* Document Download Card */}
                            <Row className="mb-5 justify-content-center">
                                <Col lg={8}>
                                    <Card className="shadow-sm border-0 text-center">
                                        <Card.Body className="p-5">
                                            <div className="mb-4">
                                                <i className="fas fa-file-word fa-4x text-primary mb-3"></i>
                                                <h3 style={{ color: '#0A4B5D' }} className="mb-3">Complete Publications List</h3>
                                                <p className="text-muted lead">
                                                    Download the complete list of all publications including:
                                                </p>
                                                <Row className="mt-4">
                                                    <Col md={4}>
                                                        <div className="mb-3">
                                                            <i className="fas fa-check text-success fa-lg me-2"></i>
                                                            <strong>Journal Articles</strong>
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="mb-3">
                                                            <i className="fas fa-check text-success fa-lg me-2"></i>
                                                            <strong>Book Chapters</strong>
                                                        </div>
                                                    </Col>
                                                    <Col md={4}>
                                                        <div className="mb-3">
                                                            <i className="fas fa-check text-success fa-lg me-2"></i>
                                                            <strong>Conference Papers</strong>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <Button 
                                                variant="primary" 
                                                size="lg"
                                                href={publicationsDocumentUrl}
                                                download
                                                className="px-5 py-3"
                                            >
                                                <i className="fas fa-download me-2"></i>
                                                Download Publications List
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>

                            {/* Publication Statistics */}
                            <Card className="bg-light border-0 mb-5">
                                <Card.Body className="p-4">
                                    <h4 className="text-center mb-4" style={{ color: '#0A4B5D' }}>
                                        Publication Metrics
                                    </h4>
                                    <Row className="text-center">
                                        <Col md={3} className="mb-3">
                                            <h3 style={{ color: '#0A4B5D' }}>170+</h3>
                                            <p className="text-muted mb-0">Total Publications</p>
                                        </Col>
                                        <Col md={3} className="mb-3">
                                            <h3 style={{ color: '#0A4B5D' }}>13,418+</h3>
                                            <p className="text-muted mb-0">Total Citations</p>
                                        </Col>
                                        <Col md={3} className="mb-3">
                                            <h3 style={{ color: '#0A4B5D' }}>52</h3>
                                            <p className="text-muted mb-0">h-index</p>
                                        </Col>
                                        <Col md={3} className="mb-3">
                                            <h3 style={{ color: '#0A4B5D' }}>2004</h3>
                                            <p className="text-muted mb-0">First Publication</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* External Links */}
                            <Card className="border-0 shadow-sm">
                                <Card.Body className="p-4">
                                    <h5 style={{ color: '#0A4B5D' }} className="text-center mb-4">
                                        View Publications Online
                                    </h5>
                                    <Row className="g-3">
                                        <Col md={4}>
                                            <Button
                                                variant="outline-primary"
                                                href="https://scholar.google.com/citations?user=Pyt_mlAAAAAJ&hl=en&oi=ao"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-100"
                                            >
                                                <i className="fas fa-graduation-cap me-2"></i>
                                                Google Scholar
                                            </Button>
                                        </Col>
                                        <Col md={4}>
                                            <Button
                                                variant="outline-primary"
                                                href="https://www.ncbi.nlm.nih.gov/myncbi/trupti.joshi.2/bibliography/public/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-100"
                                            >
                                                <i className="fas fa-database me-2"></i>
                                                PubMed
                                            </Button>
                                        </Col>
                                        <Col md={4}>
                                            <Button
                                                variant="outline-primary"
                                                href="https://orcid.org/0000-0001-8944-4924"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-100"
                                            >
                                                <i className="fab fa-orcid me-2"></i>
                                                ORCID Profile
                                            </Button>
                                        </Col>                        
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
        </div>
    );
};

export default Publications;